import CompetitorAlternativePage from '@/components/Pages/CompetitorAlternativePage';
import { OPENROUTER_ALTERNATIVE } from '@/constants/competitorAlternatives';

export default function OpenRouterAlternativePage() {
  return (
    <CompetitorAlternativePage
      title="OpenRouter Alternative — OpenAI-Compatible API"
      description="A free OpenRouter alternative: OpenAI-compatible API for GPT, Claude, Gemini, and Arya, plus a workspace on the same account."
      canonical="/openrouter-alternative"
      keywords="OpenRouter alternative, alternative to OpenRouter, OpenRouter Super Intelligence alternative, better than OpenRouter, OpenRouter competitor, apps like OpenRouter, free OpenRouter alternative, best OpenRouter alternative, OpenRouter API alternative"
      page={OPENROUTER_ALTERNATIVE}
    />
  );
}
